export function getProPriceId(): string {
  const id = (import.meta.env.VITE_STRIPE_PRICE_ID as string | undefined) ?? "";
  return id;
}

export function isProPriceConfigured(): boolean {
  return getProPriceId().length > 0;
}
